import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { FaPlus, FaRegEdit, FaFileExport } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { BsFillEyeFill } from "react-icons/bs";
import AdminNavbar from "../../Admin/Navbar/Navbar1";
import { makeAuthenticatedGETRequest, makeAuthenticatedDELETERequest } from "../../services/serverHelper";
import "../../Admin/ManageUser/User.css";
import "react-toastify/dist/ReactToastify.css";
import AdminSidebar from "../../Admin/Navbar/AdminSidebar";
import { MdMovie } from "react-icons/md";
import { Admin, performancePoints } from "../../services/apis";

const OppApplications = () => {
   const [data, setData] = useState([]);
    const [searchId, setSearchId] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [oppApp, setOppApp] = useState([]);
    const [currentFilter, setCurrentFilter] = useState("All")
    const [filterData, setFilterData] = useState([])
    const [bookings, setBookings] = useState([])
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 10;
  
    const navigateto = useNavigate();
    const token = localStorage.getItem("accessToken");
  
    const pageCount = Math.ceil(data?.length / itemsPerPage);
  
    const handlePageClick = (selectedPage) => {
      setCurrentPage(selectedPage.selected);
    };

 

 const API_A = process.env.REACT_APP_BACKEND_A;

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await makeAuthenticatedGETRequest(
          `${Admin.GET_ALL_APPLICANTS}`,
          token
        );
        // const response = await axios.get(`${API_A}/book-performance`);
        console.log("API response:", response.data);
        setBookings(response.data);
      } catch (error) {
        console.error('Error fetching bookings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  const handleDelete = async (bookingId) => {
    const response = await makeAuthenticatedDELETERequest(
      `${Admin.DELETE_APPLICANTS}/${bookingId}`,
      token
    );
    if(response.statusCode === 200){
      toast.success("Performance deleted successfully");
      setBookings((prev) => prev.filter((booking) => booking._id !== bookingId));
    }else{
      toast.error("Failed to delete performance");
    }
  };

  const filteredBookings = useMemo(() => {
    if (!searchId.trim()) return bookings;

    const search = searchId.toLowerCase();

    return bookings.filter((booking) =>
      booking?._id.toLowerCase()?.includes(search) ||
      booking?.appliedBy?.firstName?.toLowerCase()?.includes(search) ||
      booking?.appliedBy?.lastName?.toLowerCase()?.includes(search) ||
      booking?.opportunity?.title?.toLowerCase()?.includes(search) ||
      booking?.opportunity?._id?.toLowerCase()?.includes(search)
    );
  }, [bookings, searchId]);

  // Export to CSV function
    const exportToCSV = () => {
      if (!data || data.length === 0) {
        toast.warning("No data to export");
        return;
      }
  
      const toastId = toast.loading("Preparing export...");
  
      try {
        // Define CSV headers
        const headers = [
          "Name",
          "Status",
          "Approval",
          "Language",
          "Budget",
          "Location",
          "Applications",
          "ID",
          "Date of Post",
        ];
  
        // Create CSV rows
        const csvRows = [
          headers.join(","), // Header row
          ...data.map((item, index) => {
            return [
              `"${item.purpose || ""}"`,
              item.blocked ? "Blocked" : "Active",
              item.approved ? "Approved" : "Rejected",
              `"${item.languages || ""}"`,
              item.budget || 0,
              `"${item.location || ""}"`,
              oppApp[index] || 0,
              item.id || "",
              item.createdAt
                ? new Date(item.createdAt).toLocaleDateString("en-IN")
                : "-",
            ].join(",");
          }),
        ];
  
        // Combine all rows
        const csvContent = csvRows.join("\n");
  
        // Create Blob and download
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
  
        link.setAttribute("href", url);
        link.setAttribute(
          "download",
          `opportunities_${new Date().toISOString().split("T")[0]}.csv`
        );
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        toast.dismiss(toastId);
        toast.success("Data exported successfully!");
      } catch (error) {
        toast.dismiss(toastId);
        toast.error("Failed to export data");
        console.error("Export error:", error);
      }
    };
  
    // Export to Excel function (using HTML table method)
    const exportToExcel = () => {
      if (!data || data.length === 0) {
        toast.warning("No data to export");
        return;
      }
  
      const toastId = toast.loading("Preparing export...");
  
      try {
        // Create HTML table
        let tableHTML = `
          <table border="1">
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Approval</th>
                <th>Language</th>
                <th>Budget</th>
                <th>Location</th>
                <th>Applications</th>
                <th>ID</th>
                <th>Date of Post</th>
              </tr>
            </thead>
            <tbody>
        `;
  
        data.forEach((item, index) => {
          tableHTML += `
            <tr>
              <td>${item.purpose || ""}</td>
              <td>${item.blocked ? "Blocked" : "Active"}</td>
              <td>${item.approved ? "Approved" : "Rejected"}</td>
              <td>${item.languages || ""}</td>
              <td>${item.budget || 0}</td>
              <td>${item.location || ""}</td>
              <td>${oppApp[index] || 0}</td>
              <td>${item.id || ""}</td>
              <td>${
                item.createdAt
                  ? new Date(item.createdAt).toLocaleDateString("en-IN")
                  : "-"
              }</td>
            </tr>
          `;
        });
  
        tableHTML += `
            </tbody>
          </table>
        `;
  
        // Create Blob and download
        const blob = new Blob([tableHTML], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
  
        link.setAttribute("href", url);
        link.setAttribute(
          "download",
          `opportunities_${new Date().toISOString().split("T")[0]}.xls`
        );
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        toast.dismiss(toastId);
        toast.success("Data exported successfully!");
      } catch (error) {
        toast.dismiss(toastId);
        toast.error("Failed to export data");
        console.error("Export error:", error);
      }
    };

  // Load held bookings from localStorage on component mount
  useEffect(() => {
    const savedHeldBookings = localStorage.getItem('heldBookings');
    if (savedHeldBookings) {
      // setHeldBookings(JSON.parse(savedHeldBookings));
    }
  }, []);

  return (
    <>
      <AdminNavbar />
      <div className='dashboard-layout'>
        <AdminSidebar />
        <div className="admin-usercontainer">

          {/* Header Row */}
          <div className="admin-row-container">
            <h2 style={{fontSize:"40px"}}>🎬 Manage Applications</h2>
            {/* <div style={{ display: "flex", gap: "10px" }}>
              <button onClick={exportToExcel} className="export-btn">
                <FaFileExport /> Export to Excel
              </button>
              <Link to="/UploadOpportunities" className="add-btn">
                <FaPlus /> Add Opportunity
              </Link>
            </div> */}
          </div>

          

          {/* Search Bar */}
          <div className="admin-filterbar">
            <div className="searchbar">
              <IoSearch className="searchicon" />
              <input
                type="search"
                placeholder="Search by Name"
                onChange={(e) => setSearchId(e.target.value)}
                className="search"
              />
              <button 
                // onClick={filterSearch}
                 className="search-btn">
                Search
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="admin-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Email</th>
                  <th>Full Name</th>
                  <th>Phone Number</th>
                  <th>Opportunity ID</th>
                  <th>Applied on</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredBookings &&
                  filteredBookings?.map((item, index) => (
                    <tr key={index}>
                      <td>{item?._id}</td>
                      <td>
                        {item?.appliedBy?.email}
                      </td>
                      <td>{item?.appliedBy?.firstName} {item?.appliedBy?.lastName}</td>
                      <td>{item?.appliedBy?.phoneNumber?.number}</td>
                      <td>{item?.opportunity?._id || null}</td>
                      <td>
                        {(item?.appliedOn || item?.date)
                          ? new Date(item?.appliedOn || item?.date).toLocaleDateString("en-IN")
                          : "-"}
                      </td>
                      <td className="action-icons">
                        <RiDeleteBin6Line
                          title="Delete"
                          onClick={() => handleDelete(item?._id)}
                        />
                      </td>
                    </tr>
                  ))} 
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        </div>
      </div>
    </>
  );
};

export default OppApplications;